type InlineEntry = {
  sys: { id: string };
  __typename: string;
  text: string;
} | null;

type RawRichEntryData = {
  body?: {
    json?: unknown;
    links?: {
      entries?: {
        inline?: Array<InlineEntry>;
      };
    };
  } | null;
} | null | undefined;

export type FootnoteEntry = { id: string; value: string };

function walkNodes(node: unknown, footnoteIds: string[], inlineMap: Map<string, InlineEntry>) {
  if (!node || typeof node !== "object") return;
  const n = node as Record<string, unknown>;

  if (n["nodeType"] === "embedded-entry-inline") {
    const target = (n["data"] as Record<string, unknown>)?.["target"] as Record<string, unknown> | undefined;
    const sys = target?.["sys"] as Record<string, unknown> | undefined;
    const id = sys?.["id"] as string | undefined;
    if (id && inlineMap.has(id) && !footnoteIds.includes(id)) {
      footnoteIds.push(id);
    }
    return;
  }

  const content = n["content"];
  if (Array.isArray(content)) {
    for (const child of content) walkNodes(child, footnoteIds, inlineMap);
  }
}

export function extractPageFootnotes(richEntryItems: unknown[]): FootnoteEntry[] {
  const seen = new Set<string>();
  const result: FootnoteEntry[] = [];

  for (const item of richEntryItems) {
    const rawItem = item as RawRichEntryData;
    if (!rawItem?.body) continue;

    const inlineEntries = rawItem.body.links?.entries?.inline ?? [];
    const inlineMap = new Map<string, InlineEntry>();
    for (const entry of inlineEntries) {
      if (entry && entry.__typename === "Footnote") {
        inlineMap.set(entry.sys.id, entry as InlineEntry);
      }
    }

    if (inlineMap.size === 0) continue;

    const footnoteIds: string[] = [];
    walkNodes(rawItem.body.json, footnoteIds, inlineMap);

    for (const id of footnoteIds) {
      if (!seen.has(id)) {
        seen.add(id);
        result.push({ id, value: inlineMap.get(id)!.text });
      }
    }
  }

  return result;
}
